import { object } from 'prop-types'
import { MenuLinks } from '../styled-components'
import { useGetProjectDetailsQuery } from '../../../react-query/project/query/use-get-project-details-query'
import { SpinnerGrey } from '../../stories/atoms/icons/special'
import { iconSizeOptions } from '../../stories/atoms/icons/icons-sizes'
import { permissionParamOptionos } from '../../../react-query/project/constants'

const SubMenuProjectSettingsItem = ({ menuItem, itemProps }) => {
  const { data, isLoading } = useGetProjectDetailsQuery({
    projectId: menuItem.rowProjectId,
    expand: permissionParamOptionos.PERMISSIONS
  })

  const checkProjectSettings = () => {
    return data && data.permissions.includes('ViewSettings')
  }

  return (
    <MenuLinks {...itemProps} disabled={!checkProjectSettings()}>
      <span
        style={{
          width: '100%',
          display: 'flex',
          gap: '0.5rem',
          justifyContent: 'space-between',
          alignItems: 'center',
          opacity: isLoading ? 0.7 : 1
        }}
      >
        {menuItem.label}
        {isLoading && <SpinnerGrey size={iconSizeOptions['ICON-S']} />}
      </span>
    </MenuLinks>
  )
}

SubMenuProjectSettingsItem.propTypes = {
  menuItem: object,
  itemProps: object
}

export default SubMenuProjectSettingsItem
